// extracted by mini-css-extract-plugin
export default {"id":"kEn8NZhjix","confirm-input":"Prd833Y3gG","confirmInput":"Prd833Y3gG","hard-delete-checkbox":"C9gQ8kbjM4","hardDeleteCheckbox":"C9gQ8kbjM4"};